<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Realize aqui as transferências de serviços prestados ou tomados para outro
                  contribuinte.</span>
                <br />
                <span class="navigation">Transferir Escriturações</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">

          <div class="row">
            <div class="col-md-3 col-lg-2 mb-3">
              <span class="p-fluid">
                <Dropdown id="tiposEmissao" name="tiposEmissao" @change="pesquisar()" v-model="selectedTipo"
                  :options="tiposEmissao" optionLabel="name" placeholder="Tipo Emissão" @keyup.enter="pesquisar" />
              </span>
            </div>
            <div class="col-md-12 col-lg-3 mb-3">
              <span class="p-fluid">
                <InputText type="text" id="filtro" v-model="filtro" :placeholder="nomeFiltro" autocomplete="off" />
              </span>
            </div>
            <div class="col-md-3 col-lg-2 mb-3">
              <span class="p-fluid">
                <Calendar id="dataIni" name="dataFim" v-model="dataFatoGeradorIni" :showIcon="true"
                  dateFormat="dd/mm/yy" placeholder="Data Inicial" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
              </span>
            </div>
            <div class="col-md-3 col-lg-2 mb-3">
              <span class="p-fluid">
                <Calendar id="dataFim" name="dataFim" v-model="dataFatoGeradorFim" :showIcon="true"
                  dateFormat="dd/mm/yy" placeholder="Data Final" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
              </span>
            </div>
            <div class="col-md-3 col-lg-1 mb-3">
              <span class="p-fluid">
                <InputText type="text" id="filtroNumero" v-model="filtroNumero" placeholder="Número" autocomplete="off"
                  @keyup.enter="pesquisar" />
              </span>
            </div>
          </div>
          <div class="mb-2">
            <Button @click="pesquisar()" label="Pesquisar" type="button" class="p-button-primary mr-2"
              icon="pi pi-search" :disabled="loading" />
          </div>

          <hr />

          <div class="row pr-3 pl-3">
            <template>
              <Checkbox v-model="checkTodos" :binary="true" @change="selecionarTodos()" />
              <span style="padding-left: 5px; font-weight: bold; font-size: 12px">Selecionar Todos</span>
            </template>
            <DataTable :value="documentosList" :paginator="true" :rows="10" :autoLayout="true" ref="dt"
              :filters="filtersModelDocumentos">
              <template #empty>
                Nenhum resultado encontrado.
              </template>
              <Column headerStyle="width: 3%" field="selecionado" header>
                <template #body="slotProps">
                  <Checkbox v-model="slotProps.data.selecionado" :binary="true" />
                </template>
              </Column>
              <Column field="tipoDescricao" header="Tipo" bodyStyle="text-align:center" headerStyle="width: 10em"
                v-if="!notaTomador"></Column>
              <Column field="tipoDescricaoNotaTomador" header="Tipo" bodyStyle="text-align:center" v-if="notaTomador">
              </Column>
              <Column field="numeroNota" header="Número" bodyStyle="text-align:right"></Column>
              <Column field="competenciaFormatada" header="Competência" bodyStyle="text-align:center"></Column>
              <Column field="dataGeracaoFormatada" header="Geração" bodyStyle="text-align:center"></Column>
              <Column headerStyle="min-width: 10em" field="valorFormatado" header="Valor" bodyStyle="text-align:right">
              </Column>
              <Column headerStyle="min-width: 15em" field="dadosPrestador" header="Prestador">
              </Column>
              <Column headerStyle="min-width: 15em" field="dadosTomador" header="Tomador"></Column>
              <Column field="situacao" header="Situação" bodyStyle="text-align:center"></Column>
            </DataTable>
          </div>
          <div class="row">
            <hr />
          </div>
          <div class="row">
            <div class="col-md-3 col-lg-2 mb-3">
              <template>
                <Button @click="transferir()" label="Transferir Escrituração" type="button"
                  class="p-button-primary mr-2 p-button-success" icon="pi pi-check" :disabled="loading" />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog header="Confirmação" :visible.sync="displayTransferencia" :style="{ width: '50vw' }"
      :contentStyle="{ overflow: 'visible' }" :modal="true" :closable="false">
      <div><error-list :erros="erros" /></div>
      <div>
        Selecione abaixo um {{ this.selectedTipo.key === 'P' ? 'Tomador' : 'Prestador' }}, para efetuar a transferência
        nos
        documentos selecionados!<hr />
        <div class="col-md-12 col-lg-8 mb-3">
          <span class="p-fluid">
            <AutoComplete id="pessoa" v-model="selectedPessoa" :dropdown="true" :suggestions="filteredPessoas"
              @complete="searchPessoa($event)" field="detail" :placeholder="nomeFiltroTransferencia" />
          </span>
        </div>
      </div>
      <template #footer>
        <Button label="Transferir" icon="pi pi-check" @click="transferirDocumentos()" />
        <Button label="Fechar" icon="pi pi-times" @click="displayTransferencia = false" class="p-button-secondary" />
      </template>
    </Dialog>

  </div>
</template>
<script>
import { maska } from 'maska'
import TransferirEscrituracaoService from "../services/nfse/transf.escrituracao.service";
import money from "../conf/config.money";
import LoginService from "../services/acesso/login.service";
import NfsPessoaService from "../services/nfse/pessoa.service";

export default {
  props: {
    notaTomador: Boolean
  },
  directives: { maska },
  name: "TransferenciaEscrituracao",
  data() {
    return {
      money: money,
      inativo: false,
      display: false,
      loading: false,
      checkTodos: false,
      filtro: "",
      filtroNumero: "",
      erros: [],
      documentosList: [],
      filtersModelDocumentos: {},
      currentUser: null,
      filteredPessoas: null,
      selectedPessoa: null,
      dataFatoGeradorIni: null,
      dataFatoGeradorFim: null,
      selectedTipo: null,
      displayTransferencia: false,
      idContribuinteSelecionado: null,
      tiposEmissao: [
        { name: ("Serviços Prestados (Nfse)"), key: "P" },
        { name: ("Serviços Tomados (Daps Tomador)"), key: "T" }
      ]
    };
  },

  mounted() {
    document.getElementById("filtro").focus();
  },

  created() {
    this.currentUser = LoginService.currentUserValue;
    if (this.currentUser.configuracao && this.currentUser.configuracao.idBolModeloFechamento === 'E') {
      this.exibirConsultaDeclaracao = false;
    }
    this.inativo = (this.currentUser && this.currentUser.contribuinte ? !this.currentUser.contribuinte.ativo : false);
    this.selectedTipo = this.tiposEmissao[0];
    this.selectedPessoa = "";
    this.observacaoClienteNfse = this.currentUser.configuracao.idBolObservacaoNfse === "S";
  },

  methods: {
    pesquisar() {
      this.erros = []
      this.processando(true);

      if (!this.dataFatoGeradorIni) {
        this.dataFatoGeradorIni = null;
      }
      if (!this.dataFatoGeradorFim) {
        this.dataFatoGeradorFim = null;
      }
      /*if (this.selectedPessoa && this.selectedPessoa.documento){
        this.filtro = this.selectedPessoa.documento;
      } else {
        this.filtro = "";
      }*/

      TransferirEscrituracaoService.listAllFiltroPesquisar(
        this.filtro,
        this.filtroNumero,
        this.dataFatoGeradorIni,
        this.dataFatoGeradorFim,
        this.selectedTipo.key
      )
        .then(response => {
          this.documentosList = response;
          console.log(this.documentosList);
        },
          error => {
            let errorMessage = "Houve um problema ao listar as notas!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          })
        .then(() => {
          this.processando(false);
        });
    },



    searchPessoa(event) {

      if (this.idContribuinteSelecionado) {
        setTimeout(async () => {
          this.filteredPessoas = await NfsPessoaService.findAllByConttribuinte(
            this.idContribuinteSelecionado,
            event.query,
            "",
            ""
          );
        }, 250);
      }
    },

    selecionarTodos() {
      if (this.checkTodos) {
        this.documentosList.forEach(function (value) {
          value.selecionado = true;
        });
      } else {
        this.documentosList.forEach(function (value) {
          value.selecionado = false;
        });
      }
    },

    transferir() {
      this.idContribuinteSelecionado = null;
      this.displayTransferencia = false;
      this.processando(true);
      if (
        (!this.documentosList || this.documentosList.length <= 0)
      ) {
        this.$root.$emit(
          "alert:warn",
          "Selecione ao menos um documento para realizar a transferência!"
        );
        this.processando(false);
        return;
      }
      let checked = false;
      this.documentosList.forEach(function (value) {
        if (value.selecionado) {
          checked = true;
          return;
        }
      });
      if (!checked) {
        this.$root.$emit(
          "alert:warn",
          "Selecione ao menos um documento para realizar a transferência!"
        );
        this.processando(false);
      } else {
        this.idContribuinteSelecionado = this.documentosList[0].idContribuinte;
        this.displayTransferencia = true;
        this.processando(false);
      }
    },

    transferirDocumentos() {
      this.erros = [];
      this.processando(true)
      if (!this.selectedPessoa || !this.selectedPessoa.id) {
        this.$root.$emit(
          "alert:warn",
          "Selecione um " + (this.selectedTipo.key === 'P' ? 'Tomador' : 'Prestador') + "!"
        );
        this.processando(false);
        return;
      }
      let documentosSelecionados = [];
      this.documentosList.forEach(function (value) {
        if (value.selecionado) {
          documentosSelecionados.push(value);
        }
      });
      TransferirEscrituracaoService.gravar(
        this.currentUser.usuario.idUsuario,
        this.selectedPessoa.id,
        documentosSelecionados
      )
        .then(response => {
          console.log(response);
          this.$root.$emit(
            "alert:info",
            "Transferência realizada com sucesso!"
          );
          this.displayTransferencia = false;
          this.pesquisar();
          this.processando(false);
        },
          error => {
            const erros = error.response.data;
            this.erros.push(...erros);
          })
        .then(() => {
          this.processando(false);
        });
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
  },


  computed: {
    nomeFiltro: {
      get() {
        return (
          "CPF/CNPJ" +
          (this.selectedTipo.key == "T" ? " Tomador" : " Prestador")
        );
      }
    },
    nomeFiltroTransferencia: {
      get() {
        return (
          "CPF/CNPJ" +
          (this.selectedTipo.key == "T" ? " Prestador" : " Tomador")
        );
      }
    }
  }
};
</script>

<style scoped>
.scrolable-dialog {
  padding-right: 25px;
  width: 90vw;
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>